<template>
	<div class="table-cont p-2">
		<div class="row align-items-center">
			<div class="dash-title col-md p-0 mt-0">
				<h6 class="bold">الاعدادات</h6>
				<p class="mb-1">الاعدادات / تغيير كلمة المرور</p>
			</div>
		</div>

		<form @submit.prevent="changePassword">
			<div class="white-bg round7 mb-3 mt-2 p-3">
				<h6 class="bold border-bottom pt-3 pb-3 mb-4">تغيير كلمة المرور</h6>

				<div class="w-md-75">
					<div class="form-group">
						<label class="bold font14" for="Password1">
							كلمة المرور القديمة
							<span style="color: #ff3333; margin: auto 20px">*</span>
						</label>
						<div class="password-cont">
							<input
								type="password"
								class="form-control"
								id="Password1"
								placeholder="الرجاء ادخال كلمة المرور الحالية"
								v-model="old_password"
								required
							/>
							<i class="fa fa-eye color-gray" id="signInShowPassword1"></i>
						</div>
					</div>

					<div class="form-group">
						<label class="bold font14" for="Password2">
							كلمة المرور الجديدة
							<span style="color: #ff3333; margin: auto 20px">*</span>
						</label>
						<div class="password-cont">
							<input
								type="password"
								class="form-control"
								id="Password2"
								placeholder="الرجاء ادخال كلمة المرور الجديدة"
								v-model="new_password"
								required
							/>
							<i class="fa fa-eye color-gray" id="signInShowPassword2"></i>
						</div>
					</div>

					<div class="form-group">
						<label class="bold font14" for="Password3">
							تاكيد كلمة المرور الجديدة
							<span style="color: #ff3333; margin: auto 20px">*</span>
						</label>
						<div class="password-cont">
							<input
								type="password"
								class="form-control"
								id="Password3"
								placeholder="الرجاء تأكيد كلمة المرور الجديدة"
								v-model="confirm_password"
								required
							/>
							<i class="fa fa-eye color-gray" id="signInShowPassword3"></i>
						</div>
					</div>
				</div>
			</div>

			<div class="d-flex align-items-baseline">
				<button class="button1 mt-3 material-button" :disabled="disabled">
					حفظ التغييرات
					<span v-if="disabled" class="spinner-border spinner-border-sm mx-2"></span>
				</button>
			</div>
		</form>
	</div>
	<Toast />
</template>

<script>
import api from "@/core/api";
import Toast from "primevue/toast";

export default {
	name: "VendorDashboardChangePass",

	data() {
		return {
			old_password: "",
			new_password: "",
			confirm_password: "",
			disabled: false,
		};
	},

	methods: {
		async changePassword() {
			// Validate passwords match
			if (this.new_password !== this.confirm_password) {
				this.$toast.add({
					severity: "error",
					summary: "كلمة المرور الجديدة غير متطابقة",
					life: 4000,
				});
				return;
			}

			// Validate password length
			if (this.new_password.length < 6) {
				this.$toast.add({
					severity: "error",
					summary: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
					life: 4000,
				});
				return;
			}

			this.disabled = true;
			const token = localStorage.getItem("token");
			const headers = {
				Authorization: `Bearer ${token}`,
				lang: "ar",
			};

			const fd = new FormData();
			fd.append("old_password", this.old_password);
			fd.append("new_password", this.new_password);
			fd.append("confirm_password", this.confirm_password);

			try {
				const res = await api.post("store/change-password", fd, {headers});
				if (res.data.key === "success") {
					this.$toast.add({
						severity: "success",
						summary: res.data.msg,
						life: 4000,
					});
					// Clear form
					this.old_password = "";
					this.new_password = "";
					this.confirm_password = "";
				} else {
					this.$toast.add({
						severity: "error",
						summary: res.data.msg,
						life: 4000,
					});
				}
			} catch (err) {
				this.$toast.add({
					severity: "error",
					summary: "حدث خطأ في الاتصال",
					life: 4000,
				});
			} finally {
				this.disabled = false;
			}
		},
	},

	components: {
		Toast,
	},
};
</script>

<style lang="scss" scoped></style>
